export default "__VITE_PUBLIC_ASSET__90c62193__"